import React from 'react';
import { GraduationCap, Award, BookOpen } from 'lucide-react';

const EducationCard = ({ edu }) => {
  return (
    <article className="v2-edu-card">
      <header className="v2-edu-head">
        {edu.logo && (
          <div className="v2-edu-logo">
            <img
              src={edu.logo}
              alt={`${edu.institution} logo`}
              width="32"
              height="32"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}
        <div className="v2-edu-titles">
          <h3 className="v2-edu-degree">{edu.degree}</h3>
          <div className="v2-edu-field">{edu.field}</div>
          <div className="v2-edu-institution">{edu.institution}</div>
          <div className="v2-edu-period">{edu.period}</div>
        </div>
      </header>

      {edu.subjects?.length > 0 && (
        <div className="v2-edu-block">
          <div className="v2-edu-block-label">Key subjects</div>
          <div className="v2-edu-tags">
            {edu.subjects.map((s, idx) => (
              <span key={idx} className="v2-edu-tag">{s}</span>
            ))}
          </div>
        </div>
      )}

      {edu.research && (
        <div className="v2-edu-block">
          <div className="v2-edu-block-label">Research focus</div>
          <p className="v2-edu-research">{edu.research}</p>
        </div>
      )}
    </article>
  );
};

const CERT_META = {
  aws: {
    label: 'AWS',
    accent: '#FF9900',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg',
  },
  microsoft: {
    label: 'Microsoft',
    accent: '#0078D4',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg',
  },
  google: {
    label: 'Google',
    accent: '#4285F4',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
  },
  other: {
    label: 'Other',
    accent: '#86868b',
    logo: null,
  },
};

const Education3D = ({ education, certifications }) => {
  const certEntries = Object.entries(certifications || {}).filter(
    ([, items]) => Array.isArray(items) && items.length > 0
  );

  return (
    <section id="education" className="section-container v2-edu-section">
      <div className="content-wrapper">
        <div className="section-header">
          <div className="section-label">
            <GraduationCap size={18} />
            <span>Education</span>
          </div>
        </div>

        <div className="v2-edu-list">
          {education.map((edu) => (
            <EducationCard key={edu.id} edu={edu} />
          ))}
        </div>

        <div className="section-header v2-cert-section-header">
          <div className="section-label">
            <Award size={17} />
            <span>Certifications</span>
          </div>
        </div>

        <div className="v2-cert-block">
          <div className="v2-cert-groups">
            {certEntries.map(([key, items]) => {
              const meta = CERT_META[key] || { label: key, accent: '#86868b' };
              return (
                <div className="v2-cert-group" key={key}>
                  <div className="v2-cert-group-head" style={{ '--cert-accent': meta.accent }}>
                    {meta.logo ? (
                      <img
                        src={meta.logo}
                        alt={`${meta.label} logo`}
                        className="v2-cert-group-logo"
                        height="16"
                        loading="lazy"
                        decoding="async"
                      />
                    ) : (
                      <span className="v2-cert-group-dot" />
                    )}
                    <span>{meta.label}</span>
                  </div>
                  <ul className="v2-cert-list">
                    {items.map((cert, idx) => (
                      <li key={idx}>
                        <BookOpen size={12} aria-hidden="true" />
                        <span>{cert}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education3D;
